module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Центр уведомлений","settingsTitle":"Настройки уведомлений","empty":"Уведомлений пока нет"}}')
  delete Component.options._Ctor
}
